import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalActionService {
  public deleteDashboardAction$ = new Subject<void>();
}
